import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import client from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/dashboard", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await client.post("/auth/session", { session_id: sessionId });
        // Clean URL fragment
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        console.error("auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="glass-strong px-8 py-6 rounded-2xl">
        <div className="font-display text-lg">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
